/**
 * This file is part of the box.co.il project.

 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */
// todo@alexbuturlakin: this file was created from inlined code in main.php template. Looks like it need some refactoring.
;(function($) {
  $(document).ready(function() {
    $(".domainsCheck .option:not(.current)").each(function() {
      var zone = $(this).attr("data-tld");
      var dom = $(this).attr("data-domain");
      var domain_id = $(this).attr("data-domain-id");
      $(this).attr('id', 'id'+zone);
      var domain = dom + zone;

      var csrfToken     = $(this).find('[name=csrf_token]').val(),
          csrfTokenName = $(this).find('[name=csrf_token_name]').val()
      ;

      if (dom.length <= 2 || dom.indexOf(' ') != -1 || $(this).hasClass('sld-not-valid')) {
        $(this).find('.progressWhois').css('display','none');
        $(this).find('.NotSupported').css('display','block');
        $(this).find('.delayed').css('display','none');
        // $('#ok').attr('class','hidden');
        // $('#error').removeClass('hidden');
      } else {
        check_domain(domain_id, domain,csrfTokenName, csrfToken);
      }
    });

    var checkDomainFail = function(domain_id) {
      $('#whois_'+domain_id).css('display','none');
      var id = '#taken_'+domain_id;
      $(id).removeClass('hidden');
    };

    var checkDomainSuccess = function(domain_id) {
      $('#whois_'+domain_id).addClass('hidden');
      var id = '#avilable_'+domain_id;
      $(id).removeClass('hidden');
    };

    function check_domain(domain_id, domain, tokenName, token) {
      var
        csrfConfig   = Storage.getData('csrf_config'),
        tokenKey     = csrfConfig['token_key'],
        tokenNameKey = csrfConfig['token_name_key'],
        data         = {}
      ;

      // set request data
      data['domain']     = domain;
      data[tokenKey]     = token;
      data[tokenNameKey] = tokenName;

      $.ajax({
        url: "/domainsCheck/",
        type: "GET",
        data: data,
        success: function(data) {
          if(true == data['free']) {
            checkDomainSuccess(domain_id);
          } else {
            checkDomainFail(domain_id);
          }
        },
        error: function () {
          checkDomainFail(domain_id);
        }
      });
    }

    $(".check_btn").click(function() {
      var layer = $(this).closest(".option");

      var zone = layer.attr("data-tld");
      var dom = layer.attr("data-domain");
      var domain_id = layer.attr("data-domain-id");
      layer.attr('id', 'id'+zone);
      var domain = dom + zone;
      layer.find(".delayed").hide();
      layer.find(".progressWhois").show();

      check_domain(domain_id, domain);
    });
  });
})(jQuery);
